import { render, staticRenderFns } from "./CropperImage.vue?vue&type=template&id=5684fd87&"
import script from "./CropperImage.vue?vue&type=script&lang=js&"
export * from "./CropperImage.vue?vue&type=script&lang=js&"
import style0 from "./CropperImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports